import LoggedInBoilerplate from "../LoggedInBoilerplate";
import styled from "styled-components";
import NomenclatureOfSite from "./NomenclatureOfSite";
import NomenclatureOfEmployee from "./NomenclatureOfEmployee";
import NomenclatureOfVacation from "./NomenclatureOfVacation";
import NomenclatureOfDispute from "./NomenclatureOfDispute";
import NomenclatureOfComment from "./NomenclatureOfComment";
import NomenclatureOfAbsence from "./NomenclatureOfAbsence";
import NomenclatureOfZone from "./NomenclatureOfZone";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 80%;
  align-items: center;
  margin-top: 50px;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const Row2Section = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 100%;
`;

const DataColumn = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 49%;
  gap: 30px;
`;

export default function Nomenclature() {
  let title1 = "La page";
  let title2 = "de nomenclature";

  return (
    <LoggedInBoilerplate titleLine1={title1} titleLine2={title2}>
      <Row>
        <Column>
          <NomenclatureOfEmployee />
          <NomenclatureOfAbsence />
          <NomenclatureOfDispute />
          <NomenclatureOfZone />
        </Column>
        <Column>
          <NomenclatureOfSite />
          <NomenclatureOfComment />
          <NomenclatureOfVacation />
        </Column>
      </Row>
    </LoggedInBoilerplate>
  );
}
